<!--  -->
<template>
    <div class="advertisingConfig">
        <el-form label-width="104px">
            <div class="module">
                <div class="title">顶部大图（最多可选5张）</div>
                <!-- <el-form-item label="封面图" class="cover_img_box">
                    <div class="cover_img">
                        <i class="el-icon-picture" v-if="!item.topbannerurl1"></i>
                        <img class="img" :src="item.topbannerurl1 + '?' + time" v-if="item.topbannerurl1" alt="">
                        <img :src="require('@/common/images/cms/close.png')" @click="deleteTopbannerurl1" v-if="item.topbannerurl1" class="close" alt="">
                    </div>
                    <div class="btn_tips">
                        <div class="btn">
                            <UploadFile :fileRule="fileRule1" :uploadType="uploadType" @setFile="getTopbannerurl1" />
                            <el-button type="warning" @click="showScrollBox1">素材库</el-button>
                        </div> 
                        <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="item.topbannerlink1" placeholder="请输入链接地址"></el-input>
                </el-form-item> -->
                <div class="btn_tips">
                    <UploadFile ref="uploadFile1" :fileRule="fileRule1" :uploadType="uploadType" @setFile="getTopbannerurl1" />
                    <el-button type="warning" @click="showScrollBox1">素材库</el-button>
                    <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                </div>
                <SlickList lockAxis="y" v-model="item.topbanner" class="ques-slickList" :distance="5" :lockToContainerEdges="true">
                    <SlickItem v-for="(item, index) in item.topbanner" :index="index" :key="index" helper-class="listSelect"  class="slickItem">
                        <div class="img_link_box">
                            <div class="left_img_link">
                                <img class="topbanner" :src="item.topbannerurl" alt="">
                                <el-input placeholder="请输入链接地址" v-model="item.topbannerlink"></el-input>
                                <img class="close" @click="deleteTopbanner1(index)" :src="require('@/common/images/cms/close.png')" alt="">
                            </div>
                            <div class="right_drag">
                                <img :src="require('@/common/images/cms/drag.png')" alt="">
                            </div>
                        </div>
                    </SlickItem>
                </SlickList>
            </div>
            <div class="module">
                <div class="title">顶部小图1（1张）</div>
                <!-- <el-form-item label="封面图" class="cover_img_box">
                    <div class="cover_img">
                        <i class="el-icon-picture" v-if="!item.topbannerurl2"></i>
                        <img class="img" :src="item.topbannerurl2 + '?' + time" v-if="item.topbannerurl2" alt="">
                        <img :src="require('@/common/images/cms/close.png')" @click="deleteTopbannerurl2" v-if="item.topbannerurl2" class="close" alt="">
                    </div>
                    <div class="btn_tips">
                        <div class="btn">
                            <UploadFile :fileRule="fileRule1" :uploadType="uploadType" @setFile="getTopbannerurl2" />
                            <el-button type="warning" @click="showScrollBox2">素材库</el-button>
                        </div> 
                        <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="item.topbannerlink2" placeholder="请输入链接地址"></el-input>
                </el-form-item> -->
                <div class="btn_tips">
                    <UploadFile :fileRule="fileRule1" :uploadType="uploadType" @setFile="getTopbannerurl2" />
                    <el-button type="warning" @click="showScrollBox2">素材库</el-button>
                    <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                </div>
                <div class="img_link_box" v-if="item.topbannerurl2">
                    <div class="left_img_link">
                        <img class="topbanner" :src="item.topbannerurl2 + '?' + time" alt="">
                        <el-input placeholder="请输入链接地址" v-model="item.topbannerlink2"></el-input>
                        <img class="close" @click="deleteTopbannerurl2" v-if="item.topbannerurl2" :src="require('@/common/images/cms/close.png')" alt="">
                    </div>
                    <div class="right_drag">
                        <!-- <img :src="require('@/common/images/cms/drag.png')" alt=""> -->
                    </div>
                </div>
            </div>
            <div class="module">
                <div class="title">顶部小图2（1张）</div>
                <!-- <el-form-item label="封面图" class="cover_img_box">
                    <div class="cover_img">
                        <i class="el-icon-picture" v-if="!item.topbannerurl3"></i>
                        <img class="img" :src="item.topbannerurl3 + '?' + time" v-if="item.topbannerurl3" alt="">
                        <img :src="require('@/common/images/cms/close.png')" @click="deleteTopbannerurl3" v-if="item.topbannerurl3" class="close" alt="">
                    </div>
                    <div class="btn_tips">
                        <div class="btn">
                            <UploadFile :fileRule="fileRule1" :uploadType="uploadType" @setFile="getTopbannerurl3" />
                            <el-button type="warning" @click="showScrollBox3">素材库</el-button>
                        </div> 
                        <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="item.topbannerlink3" placeholder="请输入链接地址"></el-input>
                </el-form-item> -->
                <div class="btn_tips">
                    <UploadFile :fileRule="fileRule1" :uploadType="uploadType" @setFile="getTopbannerurl3" />
                    <el-button type="warning" @click="showScrollBox3">素材库</el-button>
                    <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                </div>
                <div class="img_link_box" v-if="item.topbannerurl3">
                    <div class="left_img_link">
                        <img class="topbanner" :src="item.topbannerurl3 + '?' + time" alt="">
                        <el-input placeholder="请输入链接地址" v-model="item.topbannerlink3"></el-input>
                        <img class="close" @click="deleteTopbannerurl3" v-if="item.topbannerurl3" :src="require('@/common/images/cms/close.png')" alt="">
                    </div>
                    <div class="right_drag">
                        <!-- <img :src="require('@/common/images/cms/drag.png')" alt=""> -->
                    </div>
                </div>
            </div>
            <div class="module">
                <div class="title">资讯列表中部（最多可选5张）</div>
                <!-- <el-form-item label="封面图" class="cover_img_box">
                    <div class="cover_img">
                        <i class="el-icon-picture" v-if="!item.middleadurl"></i>
                        <img class="img" :src="item.middleadurl + '?' + time" v-if="item.middleadurl" alt="">
                        <img :src="require('@/common/images/cms/close.png')" @click="deleteMiddleadurl" v-if="item.middleadurl" class="close" alt="">
                    </div>
                    <div class="btn_tips">
                        <div class="btn">
                            <UploadFile :fileRule="fileRule2" :uploadType="uploadType" @setFile="getMiddleadurl" />
                            <el-button type="warning" @click="showScrollBox4">素材库</el-button>
                        </div> 
                        <p class="tips">建议尺寸800*162px，JPG、PNG格式， 图片小于5M。</p>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="item.middleadlink" placeholder="请输入链接地址"></el-input>
                </el-form-item> -->
                <div class="btn_tips">
                    <UploadFile ref="uploadFile2" :fileRule="fileRule2" :uploadType="uploadType" @setFile="getMiddleadurl" />
                    <el-button type="warning" @click="showScrollBox4">素材库</el-button>
                    <p class="tips">建议尺寸800*162px，JPG、PNG格式， 图片小于5M。</p>
                </div>
                <SlickList lockAxis="y" v-model="item.middlead" class="ques-slickList" :distance="5" :lockToContainerEdges="true">
                    <SlickItem v-for="(item, index) in item.middlead" :index="index" :key="index" helper-class="listSelect"  class="slickItem">
                        <div class="img_link_box">
                            <div class="left_img_link">
                                <img class="topbanner" :src="item.middleadurl" alt="">
                                <el-input placeholder="请输入链接地址" v-model="item.middleadlink"></el-input>
                                <img class="close" @click="deleteMiddlead(index)" :src="require('@/common/images/cms/close.png')" alt="">
                            </div>
                            <div class="right_drag">
                                <img :src="require('@/common/images/cms/drag.png')" alt="">
                            </div>
                        </div>
                    </SlickItem>
                </SlickList>
            </div>
            <div class="module">
                <div class="title">右侧第1个（最多可选5张）</div>
                <!-- <el-form-item label="封面图" class="cover_img_box">
                    <div class="cover_img">
                        <i class="el-icon-picture" v-if="!item.navadurl1"></i>
                        <img class="img" :src="item.navadurl1 + '?' + time" v-if="item.navadurl1" alt="">
                        <img :src="require('@/common/images/cms/close.png')" @click="deleteNavadurl1" v-if="item.navadurl1" class="close" alt="">
                    </div>
                    <div class="btn_tips">
                        <div class="btn">
                            <UploadFile :fileRule="fileRule3" :uploadType="uploadType" @setFile="getNavadidurl1" />
                            <el-button type="warning" @click="showScrollBox5">素材库</el-button>
                        </div> 
                        <p class="tips">建议尺寸760*290px，JPG、PNG格式， 图片小于5M。</p>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="item.navadlink1" placeholder="请输入链接地址"></el-input>
                </el-form-item> -->
                <div class="btn_tips">
                    <UploadFile ref="uploadFile3" :fileRule="fileRule3" :uploadType="uploadType" @setFile="getNavadidurl1" />
                    <el-button type="warning" @click="showScrollBox5">素材库</el-button>
                    <p class="tips">建议尺寸760*290px，JPG、PNG格式， 图片小于5M。</p>
                </div>
                <SlickList lockAxis="y" v-model="item.navad1" class="ques-slickList" :distance="5" :lockToContainerEdges="true">
                    <SlickItem v-for="(item, index) in item.navad1" :index="index" :key="index" helper-class="listSelect"  class="slickItem">
                        <div class="img_link_box">
                            <div class="left_img_link">
                                <img class="topbanner" :src="item.navadurl" alt="">
                                <el-input placeholder="请输入链接地址" v-model="item.navadlink"></el-input>
                                <img class="close" @click="deleteNavad1(index)" :src="require('@/common/images/cms/close.png')" alt="">
                            </div>
                            <div class="right_drag">
                                <img :src="require('@/common/images/cms/drag.png')" alt="">
                            </div>
                        </div>
                    </SlickItem>
                </SlickList>
            </div>
            <div class="module">
                <div class="title">右侧第2个（最多可选5张）</div>
                <!-- <el-form-item label="封面图" class="cover_img_box">
                    <div class="cover_img">
                        <i class="el-icon-picture" v-if="!item.navadurl2"></i>
                        <img class="img" :src="item.navadurl2 + '?' + time" v-if="item.navadurl2" alt="">
                        <img :src="require('@/common/images/cms/close.png')" @click="deleteNavadurl2" v-if="item.navadurl2" class="close" alt="">
                    </div>
                    <div class="btn_tips">
                        <div class="btn">
                            <UploadFile :fileRule="fileRule3" :uploadType="uploadType" @setFile="getNavadidurl2" />
                            <el-button type="warning" @click="showScrollBox6">素材库</el-button>
                        </div> 
                        <p class="tips">建议尺寸760*290px，JPG、PNG格式， 图片小于5M。</p>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="item.navadlink2" placeholder="请输入链接地址"></el-input>
                </el-form-item> -->
                <div class="btn_tips">
                    <UploadFile ref="uploadFile4" :fileRule="fileRule3" :uploadType="uploadType" @setFile="getNavadidurl2" />
                    <el-button type="warning" @click="showScrollBox6">素材库</el-button>
                    <p class="tips">建议尺寸760*290px，JPG、PNG格式， 图片小于5M。</p>
                </div>
                <SlickList lockAxis="y" v-model="item.navad2" class="ques-slickList" :distance="5" :lockToContainerEdges="true">
                    <SlickItem v-for="(item, index) in item.navad2" :index="index" :key="index" helper-class="listSelect"  class="slickItem">
                        <div class="img_link_box">
                            <div class="left_img_link">
                                <img class="topbanner" :src="item.navadurl" alt="">
                                <el-input placeholder="请输入链接地址" v-model="item.navadlink"></el-input>
                                <img class="close" @click="deleteNavad2(index)" :src="require('@/common/images/cms/close.png')" alt="">
                            </div>
                            <div class="right_drag">
                                <img :src="require('@/common/images/cms/drag.png')" alt="">
                            </div>
                        </div>
                    </SlickItem>
                </SlickList>
            </div>
        </el-form>
        <scrollBox ref="scrollBox1" :uploadType="uploadType" @saveMaterialFile="getTopbannerurl1"></scrollBox>
        <scrollBox ref="scrollBox2" :uploadType="uploadType" @saveMaterialFile="getTopbannerurl2"></scrollBox>
        <scrollBox ref="scrollBox3" :uploadType="uploadType" @saveMaterialFile="getTopbannerurl3"></scrollBox>
        <scrollBox ref="scrollBox4" :uploadType="uploadType" @saveMaterialFile="getMiddleadurl"></scrollBox>
        <scrollBox ref="scrollBox5" :uploadType="uploadType" @saveMaterialFile="getNavadidurl1"></scrollBox>
        <scrollBox ref="scrollBox6" :uploadType="uploadType" @saveMaterialFile="getNavadidurl2"></scrollBox>
    </div>
</template>

<script>
import {getSxyTopicinfo, uploadSxyTopicinfo} from 'api/imageText'
import {mapActions} from 'vuex'
import ScrollBox from '@/base/scrollBox/scrollBox'
import UploadFile from '@/base/upload/uploadFile2'
import {SlickList, SlickItem} from 'vue-slicksort'
export default {
    data() {
        return {
            item: {
                topbanner: [],
                middlead: [],
                navad1: [],
                navad2: []
            },
            time: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            fileRule1: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 750,
                height: 420,
                nottype: true
            },
            fileRule2: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 800,
                height: 162,
                nottype: true
            },
            fileRule3: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 800,
                height: 162,
                nottype: true
            }
        }
    },
    props: ['currenttop'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getSxyTopicinfo()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        uploadSxyTopicinfo() {
            // 顶部大图
            let topbannerid1 = ''
            let topbannerlink1 = ''
            let topbannerurl1 = ''
            this.item.topbanner.forEach((item, index) => {
                topbannerid1 += item.topbannerid + ','
                topbannerlink1 += item.topbannerlink + ','
                topbannerurl1 += item.topbannerurl + ','
            })
            this.item.topbannerid1 = topbannerid1.slice(0, topbannerid1.length - 1)
            this.item.topbannerlink1 = topbannerlink1.slice(0, topbannerlink1.length - 1)
            this.item.topbannerurl1 = topbannerurl1.slice(0, topbannerurl1.length - 1)
            // 资讯列表中部
            let middleadurl = ''
            let middleadlink = ''
            let middleadid = ''
            this.item.middlead.forEach((item, index) => {
                middleadurl += item.middleadurl + ','
                middleadlink += item.middleadlink + ','
                middleadid += item.middleadid + ','
            })
            this.item.middleadurl = middleadurl.slice(0, middleadurl.length - 1)
            this.item.middleadlink = middleadlink.slice(0, middleadlink.length - 1)
            this.item.middleadid = middleadid.slice(0, middleadid.length - 1)
            // 右侧第一个
            let navadurl1 = ''
            let navadlink1 = ''
            let navadid1 = ''
            this.item.navad1.forEach((item, index) => {
                navadurl1 += item.navadurl + ','
                navadlink1 += item.navadlink + ','
                navadid1 += item.navadid + ','
            })
            this.item.navadurl1 = navadurl1.slice(0, navadurl1.length - 1)
            this.item.navadlink1 = navadlink1.slice(0, navadlink1.length - 1)
            this.item.navadid1 = navadid1.slice(0, navadid1.length - 1)
            // 右侧第二个
            let navadurl2 = ''
            let navadlink2 = ''
            let navadid2 = ''
            this.item.navad2.forEach((item, index) => {
                navadurl2 += item.navadurl + ','
                navadlink2 += item.navadlink + ','
                navadid2 += item.navadid + ','
            })
            this.item.navadurl2 = navadurl2.slice(0, navadurl2.length - 1)
            this.item.navadlink2 = navadlink2.slice(0, navadlink2.length - 1)
            this.item.navadid2 = navadid2.slice(0, navadid2.length - 1)
            console.log(this.item)
            this.setLoading(true)
            uploadSxyTopicinfo({
                data: this.item,
                success: res => {
                    this.setLoading(false)
                    this.$message.success('保存成功')
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        getSxyTopicinfo() {
            this.setLoading(true)
            getSxyTopicinfo({
                data: {topiccode: this.currenttop.topiccode},
                success: res => {
                    this.setLoading(false)
                    // 顶部大图
                    res.data.topbanner = []
                    res.data.topbannerid1arr = res.data.topbannerid1.split(',')
                    res.data.topbannerlink1arr = res.data.topbannerlink1.split(',')
                    res.data.topbannerurl1arr = res.data.topbannerurl1.split(',')
                    res.data.topbannerid1arr.forEach((item, index) => {
                        res.data.topbanner.push(
                            {
                                topbannerid: item, 
                                topbannerlink: res.data.topbannerlink1arr[index],
                                topbannerurl: res.data.topbannerurl1arr[index]
                            }
                        )
                    })
                    // 资讯列表中部
                    res.data.middlead = []
                    res.data.middleadurlarr = res.data.middleadurl.split(',')
                    res.data.middleadlinkarr = res.data.middleadlink.split(',')
                    res.data.middleadidarr = res.data.middleadid.split(',')
                    res.data.middleadurlarr.forEach((item, index) => {
                        res.data.middlead.push(
                            {
                                middleadurl: item,
                                middleadlink: res.data.middleadlinkarr[index],
                                middleadid: res.data.middleadidarr[index]
                            }
                        )
                    })
                    // 右侧第一个
                    res.data.navad1 = []
                    res.data.navadurl1arr = res.data.navadurl1.split(',')
                    res.data.navadlink1arr = res.data.navadlink1.split(',')
                    res.data.navadid1arr = res.data.navadid1.split(',')
                    res.data.navadurl1arr.forEach((item, index) => {
                        res.data.navad1.push(
                            {
                                navadurl: item,
                                navadlink: res.data.navadlink1arr[index],
                                navadid: res.data.navadid1arr[index]
                            }
                        )
                    })
                    // 右侧第二个
                    res.data.navad2 = []
                    res.data.navadurl2arr = res.data.navadurl2.split(',')
                    res.data.navadlink2arr = res.data.navadlink2.split(',')
                    res.data.navadid2arr = res.data.navadid2.split(',')
                    res.data.navadurl2arr.forEach((item, index) => {
                        res.data.navad2.push(
                            {
                                navadurl: item,
                                navadlink: res.data.navadlink2arr[index],
                                navadid: res.data.navadid2arr[index]
                            }
                        )
                    })
                    this.item = res.data
                    console.log(this.item)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        getTopbannerurl1(file) {
            if (this.item.topbanner.length < 5) {
                this.item.topbanner.push({
                    topbannerurl: file.furl,
                    topbannerid: file.key,
                    topbannerlink: ''
                })
                this.$refs.uploadFile1.uploadSetting.uploadauth = ''
            } else {
                this.$message.warning('最多5张哦！')
            }
            // this.item.topbannerurl1 = file.furl
            // this.item.topbannerid1 = file.key
            // this.time = new Date().getTime()
            // console.log(file)
        },
        getTopbannerurl2(file) {
            this.item.topbannerurl2 = file.furl
            this.item.topbannerid2 = file.key
            this.time = new Date().getTime()
        },
        getTopbannerurl3(file) {
            this.item.topbannerurl3 = file.furl
            this.item.topbannerid3 = file.key
            this.time = new Date().getTime()
        },
        getMiddleadurl(file) {
            if (this.item.middlead.length < 5) {
                this.item.middlead.push({
                    middleadurl: file.furl,
                    middleadid: file.key,
                    middleadlink: ''
                })
                this.$refs.uploadFile2.uploadSetting.uploadauth = ''
            } else {
                this.$message.warning('最多5张哦！')
            }
            // this.item.middleadurl = file.furl
            // this.item.middleadid = file.key
            // this.time = new Date().getTime()
        },
        getNavadidurl1(file) {
            if (this.item.navad1.length < 5) {
                this.item.navad1.push({
                    navadurl: file.furl,
                    navadid: file.key,
                    navadlink: ''
                })
                this.$refs.uploadFile3.uploadSetting.uploadauth = ''
            } else {
                this.$message.warning('最多5张哦！')
            }
            // this.item.navadurl1 = file.furl
            // this.item.navadid1 = file.key
            // this.time = new Date().getTime()
        },
        getNavadidurl2(file) {
            if (this.item.navad2.length < 5) {
                this.item.navad2.push({
                    navadurl: file.furl,
                    navadid: file.key,
                    navadlink: ''
                })
                this.$refs.uploadFile4.uploadSetting.uploadauth = ''
            } else {
                this.$message.warning('最多5张哦！')
            }
            // this.item.navadurl2 = file.furl
            // this.item.navadid2 = file.key
            // this.time = new Date().getTime()
        },
        deleteTopbannerurl1() {
            this.item.topbannerurl1 = ''
            this.item.topbannerid1 = ''
        },
        deleteTopbanner1(index) {
            this.item.topbanner.splice(index, 1)
        },
        deleteMiddlead(index) {
            this.item.middlead.splice(index, 1)
        },
        deleteNavad1(index) {
            this.item.navad1.splice(index, 1)
        },
        deleteNavad2(index) {
            this.item.navad2.splice(index, 1)
        },
        deleteTopbannerurl2() {
            this.item.topbannerurl2 = ''
            this.item.topbannerid2 = ''
        },
        deleteTopbannerurl3() {
            this.item.topbannerurl3 = ''
            this.item.topbannerid3 = ''
        },
        deleteMiddleadurl() {
            this.item.middleadurl = ''
            this.item.middleadid = ''
        },
        deleteNavadurl1() {
            this.item.navadurl1 = ''
            this.item.navadid1 = ''
        },
        deleteNavadurl2() {
            this.item.navadurl2 = ''
            this.item.navadid2 = ''
        },
        showScrollBox1() {
            this.$refs.scrollBox1.openDialog()
        },
        showScrollBox2() {
            this.$refs.scrollBox2.openDialog()
        },
        showScrollBox3() {
            this.$refs.scrollBox3.openDialog()
        },
        showScrollBox4() {
            this.$refs.scrollBox4.openDialog()
        },
        showScrollBox5() {
            this.$refs.scrollBox5.openDialog()
        },
        showScrollBox6() {
            this.$refs.scrollBox6.openDialog()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        UploadFile,
        ScrollBox,
        SlickList,
        SlickItem
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .advertisingConfig {
        .title {
            padding-left: 8px;
            font-size: 16px;
            color: #303133;
            line-height: 20px;
            font-weight: bold;
            border-left: 2px solid #409EFF;
            margin-bottom: 20px;
        }
        // .el-form {
        //     .el-form-item__label {
        //         text-align: left;
        //     }
        //     .cover_img_box {
        //         .el-form-item__label {
        //             line-height: 20px;
        //         }
        //         .el-form-item__content {
        //             display: flex;
        //             align-items: center;
        //             .cover_img {
        //                 width: 318px;
        //                 height: 178px;
        //                 background: #F5F7FA;
        //                 display: flex;
        //                 justify-content: center;
        //                 align-items: center;
        //                 border-radius: 4px;
        //                 margin-right: 12px;
        //                 position: relative;
        //                 .img {
        //                     width: 318px;
        //                     height: 178px;
        //                     border-radius: 4px;
        //                 }
        //                 .el-icon-picture {
        //                     font-size: 44px;
        //                     color: #DCDFE6;
        //                 }
        //                 .close {
        //                     position: absolute;
        //                     width: 20px;
        //                     height: 20px;
        //                     right: -10px;
        //                     top: -10px;
        //                     cursor: pointer;
        //                 }
        //             }
        //             .btn_tips {
        //                 .btn {
        //                     display: flex;
        //                     align-items: center;
        //                     margin-bottom: 12px;
        //                     .el-button--warning {
        //                         margin-left: 20px;
        //                     }
        //                 }
        //                 .tips {
        //                     font-size: 14px;
        //                     color: #C0C4CC;
        //                     line-height: 20px;
        //                 }
        //             }
        //         }
        //     }
        //     .el-input {
        //         width: 480px;
        //     }
        // }
        .btn_tips {
            display: flex;
            align-items: center;
            margin-bottom: 28px;
            .el-button--warning {
                margin: 0 20px;
            }
            .tips {
                font-size: 14px;
                color: #C0C4CC;
            }
        }
        .ques-slickList{
            .slickItem{
                cursor: move;
                width: 810px;
            }
        }
    }
    .img_link_box {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .left_img_link {
            width: 754px;
            margin-right: 30px;
            border: 1px solid #CCCCCC;
            border-radius: 4px;
            padding: 15px 20px;
            display: flex;
            align-items: center;
            position: relative;
            box-sizing: border-box;
            .topbanner {
                width: 214px;
                height: 120px;
                margin-right: 20px;
                border-radius: 4px;
            }
            .el-input {
                width: 480px;
                // height: 32px;
            }
            .close {
                width: 20px;
                height: 20px;
                position: absolute;
                right: -10px;
                top: -10px;
                cursor: pointer;
            }
        }
        .right_drag {
            img {
                width: 26px;
                height: 26px;
            }
        }
    }
</style>